import { HttpClient } from '@store/base';
import _ from 'lodash';
import {
  CreateEstimateCertificationConfirmRequest,
  CreateEstimateCertificationConfirmResponse,
  CreateEstimateCertificationRequest,
  CreateEstimateCertificationResponse,
  GetOnlineEstimateDetailMemberRequest,
  GetOnlineEstimateDetailMemberResponse,
  GetOnlineEstimateDetailGuestRequest,
  GetOnlineEstimateDetailGuestResponse,
  GetEstimateNotificationImagesRequest,
  GetEstimateNotificationImagesResponse,
  GetEstimateMaterialNoticesRequest,
  GetEstimateMaterialNoticesResponse,
  GetOnlineEstimateMemberRequest,
  GetOnlineEstimateMemberResponse,
  GetOnlineEstimateGuestRequest,
  GetOnlineEstimateGuestResponse,
  UpdateOnlineEstimateOrderStatusRequest,
  UpdateOnlineEstimateOrderStatusResponse,
} from '../../model';

const BASE_URL = `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/order-service/api/mall/v1/estimates`;
// OFFBEN-83 — 목록/상세 v3(version 인지) 전용. v1 BASE_URL 은 certification/order-status 공유로 불변.
const BASE_URL_V3 = `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/order-service/api/mall/v3/estimates`;

export class CreateEstimateCertificationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CreateEstimateCertificationRequest) {
    return await this.httpClient.request<CreateEstimateCertificationResponse>({
      method: 'POST',
      url: `${BASE_URL}/certification`,
      body: req,
    });
  }
}
export class CreateEstimateCertificationConfirmGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CreateEstimateCertificationConfirmRequest) {
    return await this.httpClient.request<CreateEstimateCertificationConfirmResponse>(
      {
        method: 'POST',
        url: `${BASE_URL}/certification/confirm`,
        body: req,
      },
    );
  }
}

export class UpdateOnlineEstimateOrderStatusGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: UpdateOnlineEstimateOrderStatusRequest) {
    return await this.httpClient.request<UpdateOnlineEstimateOrderStatusResponse>(
      {
        method: 'PUT',
        url: `${BASE_URL}/${req.estimateId}/order-status`,
      },
    );
  }
}

/**
 * OFFBEN-83 — 온라인견적서 v3(version 인지) 목록/상세 게이트웨이.
 */
export class GetOnlineEstimateMemberGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetOnlineEstimateMemberRequest) {
    return await this.httpClient.request<GetOnlineEstimateMemberResponse>({
      method: 'GET',
      url: `${BASE_URL_V3}`,
      body: req,
    });
  }
}

export class GetOnlineEstimateGuestGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetOnlineEstimateGuestRequest) {
    return await this.httpClient.request<GetOnlineEstimateGuestResponse>({
      method: 'GET',
      url: `${BASE_URL_V3}/guest`,
      body: req,
    });
  }
}

export class GetOnlineEstimateDetailMemberGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetOnlineEstimateDetailMemberRequest) {
    return await this.httpClient.request<GetOnlineEstimateDetailMemberResponse>(
      {
        method: 'GET',
        url: `${BASE_URL_V3}/${req.estimateId}`,
      },
    );
  }
}

export class GetOnlineEstimateDetailGuestGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetOnlineEstimateDetailGuestRequest) {
    return await this.httpClient.request<GetOnlineEstimateDetailGuestResponse>({
      method: 'GET',
      url: `${BASE_URL_V3}/${req.estimateId}/guest`,
      body: _.omit(req, 'estimateId'),
    });
  }
}

/**
 * HSMALL-15407 — 견적 알림톡 내 참고이미지 조회. 비로그인 접근 가능(토큰 기반).
 */
export class GetEstimateNotificationImagesGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetEstimateNotificationImagesRequest) {
    return await this.httpClient.request<GetEstimateNotificationImagesResponse>(
      {
        method: 'GET',
        url: `${BASE_URL}/notification-images`,
        body: req,
      },
    );
  }
}

/**
 * SALES-14036 — 소재고지 알림톡 링크 고지내역 조회. 비로그인 접근 가능(토큰 기반).
 * 정렬(발송일시 내림차순)은 BE 가 보장하므로 클라이언트에서 재정렬하지 않는다.
 */
export class GetEstimateMaterialNoticesGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetEstimateMaterialNoticesRequest) {
    return await this.httpClient.request<GetEstimateMaterialNoticesResponse>({
      method: 'GET',
      url: `${BASE_URL}/material-notices`,
      body: req,
    });
  }
}
